// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Storefront20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Storefront20Filled: FC<Storefront20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M17.166 9.261v6.183c0 .428-.156.794-.467 1.1a1.552 1.552 0 0 1-1.125.456H4.426c-.438 0-.813-.152-1.125-.457a1.481 1.481 0 0 1-.467-1.099V9.261a2.673 2.673 0 0 1-.707-1.05c-.166-.428-.17-.894-.01-1.4l.836-2.644c.106-.337.295-.616.567-.836.272-.22.588-.331.946-.331h11.068c.358 0 .67.107.936.32.265.215.457.497.577.847l.836 2.644c.16.506.156.966-.01 1.38a3.066 3.066 0 0 1-.707 1.07Zm-5.414-.817c.358 0 .63-.12.816-.36.186-.24.259-.508.219-.806l-.438-2.722h-1.553v2.877c0 .273.093.51.279.71.186.201.411.301.677.301Zm-3.583 0c.305 0 .554-.1.746-.3a.992.992 0 0 0 .289-.71V4.555H7.65l-.438 2.722a.97.97 0 0 0 .21.816c.192.234.44.35.746.35Zm-3.544 0a.886.886 0 0 0 .627-.252c.18-.169.289-.383.329-.642l.438-2.994H4.466L3.67 7.16c-.08.26-.037.538.13.836.165.298.44.447.825.447Zm10.75 0c.385 0 .663-.149.836-.447.172-.298.212-.577.12-.836l-.837-2.605h-1.513l.438 2.994c.04.26.15.473.329.642.179.168.388.252.627.252Z" />
        </svg>
    );
};

export default Storefront20Filled;
